import React, { FC } from 'react';
import { Field } from 'formik';
import { AnalyticsProps, Placement, Tooltip } from '@inplayer-org/inplayer-ui';
import styled from 'styled-components';

// components
import RadioField from 'components/Fields/Radio';
import CommonIcon from 'components/CommonIcon';

const Div = styled.div`
  display: flex;
  align-items: center;

  & label {
    margin-right: 0.25em;
    width: fit-content;

    span {
      width: fit-content;
    }
  }
`;

interface Props extends AnalyticsProps {
  name: string;
  value: string;
  label: string;
  tooltip?: string;
  tooltipPosition?: Placement;
}

const RadioFieldWithInfo: FC<Props> = ({ name, value, label, tooltip, tooltipPosition = 'right', tag = '' }) => (
  <Div>
    <Field tag={tag} name={name} value={value} label={label} component={RadioField} />
    {tooltip && (
      <Tooltip placement={tooltipPosition} content={tooltip}>
        <CommonIcon name="info" isLabelIcon />
      </Tooltip>
    )}
  </Div>
);

export default RadioFieldWithInfo;
